import { IMasterUpdateValidations } from '../../../masters_management/utility'
import { Box } from '@mui/material'
import React from 'react'
import { ToolButton } from './TreeManagementToolRouteButton'

export function TreeValidations({
  validations,
  showAll = false,
}: {
  validations?: IMasterUpdateValidations
  showAll?: boolean
}) {
  if (!validations) return null

  return (
    <Box>
      <QuestionValidation validations={validations} showAll={showAll} />
      <PresentationFlagValidation validations={validations} showAll={showAll} />
      <PresentationEditableVerification
        validations={validations}
        showAll={showAll}
      />
      <XRefValidation validations={validations} showAll={showAll} />
      <StagingImagesValidation validations={validations} showAll={showAll} />
    </Box>
  )
}

function QuestionValidation({
  showAll,
  validations: { badQuestions, treeId, versionId },
}: {
  validations: IMasterUpdateValidations
  showAll: boolean
}) {
  if (!badQuestions.length) {
    return showAll ? <Box>No bad questions detected</Box> : null
  }
  return (
    <Box>
      {badQuestions.length} questions are in a bad state
      <ToolButton
        toolId={'Questions Verification'}
        treeId={treeId}
        versionId={versionId}
      />
    </Box>
  )
}

function PresentationFlagValidation({
  showAll,
  validations,
}: {
  validations: IMasterUpdateValidations
  showAll: boolean
}) {
  if (!validations.presentationsFlagIssues.length) {
    return showAll ? (
      <Box>No presentations with flag issues detected</Box>
    ) : null
  }
  return (
    <Box>
      {`${validations.presentationsFlagIssues.length} presentations have flag issues`}
    </Box>
  )
}

function PresentationEditableVerification({
  showAll,
  validations: { editablePresentations },
}: {
  validations: IMasterUpdateValidations
  showAll: boolean
}) {
  if (!editablePresentations.length) {
    return showAll ? <Box>No editable presentations found</Box> : null
  }
  return (
    <Box>
      There are {editablePresentations.length} presentations that need to be
      fixed
    </Box>
  )
}

function XRefValidation({
  showAll,
  validations: { treeId, versionId, hasXRefLinkIssues },
}: {
  validations: IMasterUpdateValidations
  showAll: boolean
}) {
  if (!hasXRefLinkIssues) {
    return showAll ? <Box>No XRef issues found</Box> : null
  }
  return (
    <Box>
      There are XRef Link Issues
      <ToolButton
        toolId={'Node Cross Association'}
        treeId={treeId}
        versionId={versionId}
      />
    </Box>
  )
}

function StagingImagesValidation({
  validations: { treeId, versionId, stagingImagesInDrawingQuestions },
  showAll,
}: {
  validations: IMasterUpdateValidations
  showAll: boolean
}) {
  if (!stagingImagesInDrawingQuestions.length) {
    return showAll ? (
      <Box>No drawing questions with staging images found</Box>
    ) : null
  }
  return (
    <Box>
      There are {stagingImagesInDrawingQuestions.length} drawing questions with
      staging images
      <ToolButton
        toolId={'Image Sources'}
        treeId={treeId}
        versionId={versionId}
      />
    </Box>
  )
}
